import { render } from "./RedundantResources.vue?vue&type=template&id=5f42f858&scoped=true"
import script from "./RedundantResources.vue?vue&type=script&lang=js"
export * from "./RedundantResources.vue?vue&type=script&lang=js"

import "./RedundantResources.vue?vue&type=style&index=0&id=5f42f858&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f42f858"]])

export default __exports__